module.exports = __webpack_public_path__ + "img/29.2b79de9d.jpg";